/** @format */

import { AxiosError, AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../constants/api";
import { TLicenseUpdateRequest } from "../../redux-modules/declarations/maps/license";
import apiClient from "../../utils/apiClient";

export const apiLicenseUpdate = (
  data: TLicenseUpdateRequest,
): Promise<{ response?: AxiosResponse; error?: AxiosError }> =>
  apiClient
    .put(API_ENDPOINTS.LICENSE_DELETE.replace(":id", `${data.id}`), data)
    .then(response => ({ response }))
    .catch(error => ({ error }));
